import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var RepayWithATokens = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'repayWithATokens',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaHandHoldingUsd }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    interestRateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }], isPreview: true }),
                },
            },
            output: {
                amountRepaid: new FctValue({ innerIndex: 0 }),
            },
        });
    },
    // TODO: assetFlow needs to find the aToken address for the asset and return correct assetFlow
});
